
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M7.76012 7.83L7.78012 7.85C8.13012 8.2 8.67012 8.23 9.08012 7.94C9.91012 7.37 10.9201 7.02 12.0001 7.02C13.0801 7.02 14.0901 7.37 14.9201 7.95C15.3201 8.24 15.8701 8.21 16.2201 7.86L16.2401 7.84C16.6601 7.42 16.6301 6.7 16.1501 6.35C14.9801 5.5 13.5501 5 12.0001 5C10.4501 5 9.02012 5.5 7.86012 6.34C7.37012 6.69 7.34012 7.41 7.76012 7.83ZM12.0001 1C9.38012 1 6.97012 1.93 5.08012 3.47C4.62012 3.84 4.57012 4.53 5.00012 4.96C5.36012 5.32 5.93012 5.35 6.32012 5.03C7.86012 3.76 9.85012 3 12.0001 3C14.1501 3 16.1401 3.76 17.6901 5.03C18.0801 5.35 18.6501 5.32 19.0101 4.96C19.4301 4.54 19.3901 3.85 18.9301 3.47C17.0301 1.93 14.6201 1 12.0001 1ZM14.8601 10.01L9.14012 10C8.51012 10 8.00012 10.51 8.00012 11.14V20.85C8.00012 21.48 8.51012 21.99 9.14012 21.99H14.8501C15.4801 21.99 15.9901 21.48 15.9901 20.85V11.14C16.0001 10.51 15.4901 10.01 14.8601 10.01ZM15.0001 20H9.00012V12H15.0001V20Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-speaker-phone`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSpeakerPhone

    ```js
    <b-new-b-icon-speaker-phone />
    ```
</docs>


